import { render, staticRenderFns } from "./ClienteSemMovimentacao.vue?vue&type=template&id=5c76d67b&scoped=true&"
import script from "./ClienteSemMovimentacao.vue?vue&type=script&lang=js&"
export * from "./ClienteSemMovimentacao.vue?vue&type=script&lang=js&"
import style0 from "./ClienteSemMovimentacao.vue?vue&type=style&index=0&id=5c76d67b&scoped=true&lang=css&"
import style1 from "./ClienteSemMovimentacao.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76d67b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
